export default __webpack_public_path__ + "static/media/Playfair.3bab1045.ttf";